export default function Marquee({ items = [], speed = 28, separator = "✦" }) {
  const dup = [...items, ...items];
  return (
    <div className="marquee py-3">
      <div className="marquee-track" style={{ animationDuration: `${speed}s` }}>
        {dup.map((it, i) => (
          <span key={i} className="flex items-center gap-3 font-mono-x text-sm uppercase tracking-widest font-bold whitespace-nowrap">
            {it}
            <span className="text-[#FF1A8C]">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
